export default [
  '_benzonitrile',
  '_cyclohexane',
  '_acetaminophen',
  '_ethanol',
  '_jade',
  '_aceticAcid',
  '_deoxyephedrineHydrochloride',
  '_polypropylene',
  '_crystal',
  '_toiletWater',
  '_cubicZircon',
  '_ephedrine',
  '_aspirine',
  '_ibuprofen',
  '_benitoite',
  '_Brucite',
  '_olivine',
  '_gasoline',
  '_atropine',
  '_acetylsalicylicAcid',
  '_diamond',
  '_xiuyu',
  '_starch',
  '_artificialStrontiumBoroaluminate',
  '_polystyrene',
  '_sucrose',
  '_heroinHydrochloride',
  '_hotanJade'
];
